module.exports = __webpack_public_path__ + "static/desktop-feae6f90f5485928ea0ad56e080b52ba.png";